<template>
  <div>
    <main role="main">
      <full-banner :product-detail="productDetail"/>
      <album />
      <our-works :product-detail="productDetail"/>
      <price-detail v-if="productDetail" :product-detail="productDetail"/>
      <price v-if="!productDetail"/>
      <gallery :product-detail="productDetail"/>
      <poster :product-detail="productDetail"/>
      <testimonial :product-detail="productDetail"/>
<!--      <div class="pt-5 mt-5" v-if="enableTrustpilot">-->
<!--        &lt;!&ndash; TrustBox widget - Mini &ndash;&gt;-->
<!--        <div class="trustpilot-widget" data-locale="de-DE" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="5ec8575f40a1620001fdb618" data-style-height="100%" data-style-width="100%" data-theme="light">-->
<!--          <a href="https://de.trustpilot.com/review/sternenhimmel-poster.de" target="_blank" rel="noopener">Trustpilot</a>-->
<!--        </div>-->
<!--        &lt;!&ndash; End TrustBox widget &ndash;&gt;-->
<!--      </div>-->
      <hr class="featurette-divider" />
      <service />
    </main>

    <Footer />
    <footer-payment />
  </div>
</template>

<script>
import FullBanner from "../components/FullBanner";
import Album from "../components/Album";
import OurWorks from "../components/OurWorks";
import Price from "../components/Price";
import PriceDetail from "../components/PriceDetail";
import Gallery from "../components/Gallery";
import Poster from "../components/Poster";
import Testimonial from "../components/Testimonial";
import Service from "../components/Service";
import Footer from "../components/Footer";
import FooterPayment from "../components/FooterPayment";

export default {
  name: "Home",
  components: {
    FullBanner,
    Album,
    OurWorks,
    Price,
    PriceDetail,
    Gallery,
    Poster,
    Testimonial,
    Service,
    Footer,
    FooterPayment,
  },
  data() {
    return {
      enableTrustpilot: (process.env.VUE_APP_ENABLE_TRUSTPILOT === '1'),
      productDetail: this.$route.query.productDetail,
    };
  },
  mounted: function () {
    let hash = this.$route.hash;
    if (hash) {
      setTimeout(function () {
        let element = document.querySelector(hash);
        if (element) {
          window.scroll({
            top: window.scrollY + element.getBoundingClientRect().top,
            behavior: "smooth",
          });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  },
};
</script>